import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

@Component({
  selector: 'app-rental-resource-assignment-refuel-form',
  templateUrl: './rental-resource-assignment-refuel-form.component.html',
  styleUrls: ['./rental-resource-assignment-refuel-form.component.scss']
})
export class RentalResourceAssignmentRefuelFormComponent {

  refuelForm: FormGroup;
  refuelFormControl: FormControl;
  controlKey: string;
  label: string;
  suffix: string;

  _task: Task;
  @Input() set task(task: Task) {
    // strange gewurstel for problems with getting the task multiple times
    if(task && task?.formControlTemplate && (this._task?.id != task?.id)){
      this._task = task;
      this.controlKey = this._task?.formControlTemplate?.body[0]?.controls[0]?.controls[0]?.key;
      this.label = this._task?.formControlTemplate?.body[0]?.controls[0]?.controls[0]?.settings?.label;
      this.suffix = this._task?.formControlTemplate?.body[0]?.controls[0]?.controls[0]?.settings?.suffix;
      this.buildForm();
    }

  }
  @Output() complete = new EventEmitter<{ task: Task, formModelInput?: any }>();

  constructor(
  ) {
    
  }

  buildForm() {
    this.refuelForm = new FormGroup({});
    this.refuelFormControl = new FormControl( undefined, Validators.required);
    this.refuelForm.addControl(this.controlKey, this.refuelFormControl);
    if(this._task?.state == 'COMPLETED'){
      let refueled = this._task?.formControlTemplate?.body[0]?.controls[0]?.controls[0].settings?.value?.refueled;
      this.refuelFormControl.setValue(refueled);
      this.refuelForm.disable();
    }
  }

  completeTask() {
    let refueledValue = {
      refueled: this.refuelForm.get(this.controlKey).value
    }
    let controlModelInput = {
      controlKey: this.controlKey,
      value : refueledValue
    };
    let controlModelInputs = [];
    controlModelInputs.push(controlModelInput);
    let formModelInput = {
      controlModelInputs: controlModelInputs
    };
    
    this.complete.emit({
      task: this._task,
      formModelInput: formModelInput
    });
    this._task = undefined;
  }
  
  
}
